import { useCallback, useContext } from 'react';
import { WorkflowAction } from '~/lib/types/workflow-types';
import { WorkflowContext } from '~/providers/workflowContext';

export default function useWorkflowActions() {
  const { state, dispatch } = useContext(WorkflowContext);

  const addCompletedAction = useCallback(
    (payload: WorkflowAction) => dispatch({ type: 'COMPLETED_ACTION', payload }),
    [dispatch]
  );

  const storeWorkflowData = useCallback(
    (name: WorkflowAction, payload: boolean | string | number | object) =>
      dispatch({ type: 'SET_DATA', name, payload }),
    [dispatch]
  );

  const clearCompletedActions = useCallback(
    (completed: WorkflowAction[]) => dispatch({ type: 'CLEAR_COMPLETED_ACTIONS', payload: completed }),
    [dispatch]
  );

  return {
    completedActions: state.completedActions,
    workflowData: state.data,
    storeWorkflowData: storeWorkflowData,
    addCompletedAction: addCompletedAction,
    clearCompletedActions: clearCompletedActions
  };
}
